import {
  AuxEngineReport,
  EngineReportsResponse,
  MainEngineReport,
} from '@navstation-portal/reporting/data-model/engine-reports';
import { EngineReports } from './engine-reports-events';

export function mapEngineReportsResponse(response: EngineReportsResponse): EngineReports {
  const parseSfoc = (value: string): number | undefined => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  };

  const meReports: MainEngineReport[] = (response.me_reports ?? [])
    .map((report) => ({
      id: report.id,
      reportNumber: report.reportNumber,
      reportTo: report.reportTo,
      engineName: report.engineName,
      indicatedPower: report.indicatedPower,
      effectivePower: report.effectivePower,
      pRise: report.pRise,
      sfocLCVCorrected: parseSfoc(report.sfocLCVCorrected),
      status: report.status,
      download: 'Download',
    }))
    .sort((a, b) => b.reportNumber - a.reportNumber);

  const aeReports: AuxEngineReport[] = (response.ae_reports ?? [])
    .map((report) => ({
      id: report.id,
      reportNumber: report.reportNumber,
      reportTo: report.reportTo,
      engineName: report.engineName,
      load: report.load,
      pMax: report.pMax,
      fuelPumpIndex: report.fuelPumpIndex,
      status: report.status,
    }))
    .sort((a, b) => b.reportNumber - a.reportNumber);

  return { meReports, aeReports };
}
